module.exports = __webpack_public_path__ + "img/fickett-&-crockett.4aa66cc9.png";